import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import { get, post } from "@/services/http/platformServer";

export enum RemarkReferenceType {
    BUYER = "BUYER",
    SELLER = "SELLER",
}

/**
 * 自动推送订单规则
 */
export enum AutoPushOrderToSupplierPushType {
    PUSH_BY_PRODUCT_ASSOCIATION = "PUSH_BY_PRODUCT_ASSOCIATION",
    PUSH_BY_RULE = "PUSH_BY_RULE",
}

/**
 * 自动推送订单orderItem的匹配类型
 */
export enum AutoPushOrderItemMatchType {
    ALL = "ALL",
    EXTERNAL_ID_ENDS_WITH = "EXTERNAL_ID_ENDS_WITH",
    EXTERNAL_ID_STARTS_WITH = "EXTERNAL_ID_STARTS_WITH",
}

export interface AutoPushOrderToSupplierRule {
    id: number;
    orderItemMatchType: AutoPushOrderItemMatchType;
    supplierShopId: number;
    value?: string;
}

export interface AutoPushOrderToSupplierSetting {
    id: number;
    /**延迟 毫秒 */
    delayMills: number;
    enabled: boolean;
    pushType: AutoPushOrderToSupplierPushType;
    rules: AutoPushOrderToSupplierRule[];
    shopId: number;
    /**备注规则类型 */
    remarkReferenceType: RemarkReferenceType;
    lastEnabledTime: string;
    excludeOrderFlags: OrderSellerRemarksFlag[];
}

/**
 * 获取分销自动推单设置
 */
export function getAutoPushOrderToSupplierSetting(shopId: number) {
    return get<AutoPushOrderToSupplierSetting>(shopId, "/auto_push_order_to_supplier_setting", {
        shopId,
    });
}

interface SaveParams extends Omit<AutoPushOrderToSupplierSetting, "id" | "rules" | "lastEnabledTime"> {
    rules: (Omit<AutoPushOrderToSupplierRule, "id"> & { id?: number })[];
}

export function saveAutoPushOrderToSupplierSetting(params: SaveParams): Promise<AutoPushOrderToSupplierSetting> {
    return post(params.shopId, "/auto_push_order_to_supplier_setting/save", params);
}

/** 按当前设置来重新推送订单到供货商 */
export function pushOrderWithSetting(shopId: number) {
    return post(shopId, "/auto_push_order_to_supplier_setting/push_order_with_setting", undefined, {
        params: { shopId },
    });
}

interface SettingSavePreCheckResult {
    /** 自动提单设置中涉及到的已取消合作的供货商店铺ID列表 */
    suspendedSupplierShopIds: number[];
}

/** 代理商保存自动推单设置预检 */
export function preCheckBeforeSaveAutoPushSetting(autoPushOrderToSupplierSetting: SaveParams) {
    return post<SettingSavePreCheckResult>(
        autoPushOrderToSupplierSetting.shopId,
        "/auto_push_order_to_supplier_setting/pre_check_before_save",
        autoPushOrderToSupplierSetting,
    );
}
